import { Injectable } from '@angular/core';
import { ArboService } from 'src/app/services/arbo.service';
import { HttpService } from 'src/app/services/http.service';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class SectionService {
  private type = 'Section';

  // Cache em memória
  private _listOrgsCache: { data: any; timestamp: number } | null = null;
  private CACHE_TTL = 5 * 60 * 1000; // 5 minutos

  constructor(
    private arboService: ArboService,
    private httpService: HttpService
  ) { }

  create(data) { return this.arboService.create(this.type,data); }
  get(id)      { return this.arboService.get(this.type,id);      }
  list(id)     { return this.arboService.list(this.type,id);     }
  update(data) {
    return this.arboService.update(this.type,data);
  }
  delete(id)   { return this.arboService.delete(this.type,id);   }

  /**
   * Lista as organizações do usuário logado
   * Endpoint: GET /Section/list-orgs (root=todas, user=suas)
   */
  listOrgs() {
    if (this._listOrgsCache && (Date.now() - this._listOrgsCache.timestamp < this.CACHE_TTL)) {
      return Promise.resolve(this._listOrgsCache.data);
    }
    return this.httpService.get(`${environment.arboUrl}/${this.type}/list-orgs`)
      .then(data => {
        this._listOrgsCache = { data, timestamp: Date.now() };
        return data;
      });
  }

  invalidateCache() {
    this._listOrgsCache = null;
  }

  renameOrganization(id: number | string, name: string, userId?: number) {
    const payload: any = { name };

    if (userId) {
      payload.userId = userId;
    }

    this.invalidateCache();
    return this.httpService.put(
      `${environment.arboUrl}/Section/org/${id}`,
      payload
    );
  }

  deleteOrganization(id: number | string) {
    this.invalidateCache();
    return this.httpService.delete(
      `${environment.arboUrl}/Section/org/${id}`
    );
  }

  /**
   * Cria uma organização completa via POST /Section/org
   * O backend cria: Section + Client + Membership + MembershipRole em uma única chamada
   */
  async createOrganization(data: { name: string; ownerId: number }): Promise<any> {
    const response: any = await this.httpService.post(
      `${environment.arboUrl}/Section/org`,
      {
        name: data.name,
        userId: data.ownerId,
        parentSectionId: 1  // Sempre filha da Section 1 (root)
      }
    );

    this.invalidateCache();
    return response.data?.org || response;
  }

  /**
   * Cria um Membership vinculando um usuário a uma section existente
   * Usado quando POST /Client/ já criou a Section mas não o Membership
   */
  createMembership(userId: number, sectionId: number) {
    return this.httpService.post(
      `${environment.arboUrl}/Membership`,
      { userId, sectionId }
    );
  }

}
